module.exports = __webpack_public_path__ + "static/remote-workers-want-flexibility-not-complete-autonomy-ecb7dae12e8b44e40b7c84cc6022d069.png";